'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n\tcolor: ', ';\n\ttext-align: ', ';\n'], ['\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n\tcolor: ', ';\n\ttext-align: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n\tcolor: ', ';\n\tmargin: 0;\n'], ['\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n\tcolor: ', ';\n\tmargin: 0;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n\tcolor: ', ';\n\tmargin: 0;\n'], ['\n    font-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n\tcolor: ', ';\n\tmargin: 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n\tcolor: ', ';\n\tmargin: 0;\n\tword-wrap: break-word;\n'], ['\n    font-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n\tcolor: ', ';\n\tmargin: 0;\n\tword-wrap: break-word;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../constants/colors');

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _text = require('../../../constants/text');

var _formattedText = require('../formattedText');

var _formattedText2 = _interopRequireDefault(_formattedText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DisplayComponent = _styledComponents2.default.div(_templateObject, function (_ref) {
	var top = _ref.top;
	return (0, _getSize2.default)(top);
}, function (_ref2) {
	var bottom = _ref2.bottom;
	return (0, _getSize2.default)(bottom);
}, function (_ref3) {
	var left = _ref3.left;
	return (0, _getSize2.default)(left);
}, function (_ref4) {
	var right = _ref4.right;
	return (0, _getSize2.default)(right);
}, function (_ref5) {
	var inverse = _ref5.inverse;
	return inverse && _colors.Colors.LightMode || _colors.Colors.SecondaryText;
}, function (_ref6) {
	var textAlign = _ref6.textAlign;
	return textAlign || 'center';
});

var D1 = _styledComponents2.default.h1(_templateObject2, _text.TextSizes.DisplayFontFamily, function (_ref7) {
	var bold = _ref7.bold;
	return bold === false ? _text.TextSizes.WeightNormal : _text.TextSizes.WeightSemiBold;
}, _text.TextSizes.D1FontSize, _text.TextSizes.D1LineHeight, function (_ref8) {
	var inverse = _ref8.inverse,
	    color = _ref8.color;
	return color ? color : inverse ? _colors.Colors.LightMode : _colors.Colors.SecondaryText;
});

var D2 = _styledComponents2.default.h2(_templateObject3, _text.TextSizes.DisplayFontFamily, function (_ref9) {
	var bold = _ref9.bold;
	return bold === false ? _text.TextSizes.WeightNormal : _text.TextSizes.WeightSemiBold;
}, _text.TextSizes.D2FontSize, _text.TextSizes.D2LineHeight, function (_ref10) {
	var inverse = _ref10.inverse,
	    color = _ref10.color;
	return color ? color : inverse ? _colors.Colors.LightMode : _colors.Colors.SecondaryText;
});

var D3 = _styledComponents2.default.h3(_templateObject4, _text.TextSizes.DisplayFontFamily, function (_ref11) {
	var bold = _ref11.bold;
	return bold === false ? _text.TextSizes.WeightNormal : _text.TextSizes.WeightSemiBold;
}, _text.TextSizes.D3FontSize, _text.TextSizes.D3LineHeight, function (_ref12) {
	var inverse = _ref12.inverse,
	    color = _ref12.color;
	return color ? color : inverse ? _colors.Colors.LightMode : _colors.Colors.SecondaryText;
});

var D4 = _styledComponents2.default.h4(_templateObject4, _text.TextSizes.DisplayFontFamily, function (_ref13) {
	var bold = _ref13.bold;
	return bold === false ? _text.TextSizes.WeightNormal : _text.TextSizes.WeightSemiBold;
}, _text.TextSizes.D4FontSize, _text.TextSizes.D4LineHeight, function (_ref14) {
	var inverse = _ref14.inverse,
	    color = _ref14.color;
	return color ? color : inverse ? _colors.Colors.LightMode : _colors.Colors.SecondaryText;
});

var Display = function (_React$Component) {
	_inherits(Display, _React$Component);

	function Display() {
		_classCallCheck(this, Display);

		return _possibleConstructorReturn(this, (Display.__proto__ || Object.getPrototypeOf(Display)).apply(this, arguments));
	}

	_createClass(Display, [{
		key: 'getStyledComponent',
		value: function getStyledComponent() {
			var outputText = _react2.default.createElement(_formattedText2.default, { text: this.props.text });

			var size = this.props.size;
			if (!size) {
				size = _sizes.Sizes.md;
			}

			switch (size) {
				case _sizes.Sizes.xs:
					return _react2.default.createElement(
						D4,
						{ inverse: this.props.inverse, color: this.props.color, className: this.props.className, bold: this.props.bold },
						outputText
					);

				case _sizes.Sizes.sm:
					return _react2.default.createElement(
						D3,
						{ inverse: this.props.inverse, color: this.props.color, className: this.props.className, bold: this.props.bold },
						outputText
					);

				default:
					return _react2.default.createElement(
						D2,
						{ inverse: this.props.inverse, color: this.props.color, className: this.props.className, bold: this.props.bold },
						outputText
					);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.props.text || this.props.text === "" || this.props.text === " ") {
				return null;
			}

			return _react2.default.createElement(
				DisplayComponent,
				{
					textAlign: this.props.textAlign,
					top: this.props.top,
					bottom: this.props.bottom,
					left: this.props.left,
					right: this.props.right,
					inverse: this.props.inverse,
					className: this.props.className
				},
				this.getStyledComponent()
			);
		}
	}]);

	return Display;
}(_react2.default.Component);

exports.default = Display;